<template>
    <Transition
        enter-active-class="transition ease-out duration-500"
        enter-from-class="transform opacity-0 scale-95"
        enter-to-class="transform opacity-100 scale-100"
        leave-active-class="transition ease-in duration-400"
        leave-from-class="transform opacity-100 scale-100"
        leave-to-class="transform opacity-0 scale-95"
    >
        <MuvalButton
            v-if="session.hasSession"
            class="border-muval-gray-1! text-muval-gray-1! relative block bg-white"
            secondary
            type="button"
            @click="openSummaryDialog"
        >
            <div class="relative flex">
                <div class="absolute -top-2 right-[-1.1rem]">
                    <span class="relative flex h-3 w-3">
                        <span
                            :class="form.loading ? 'animate-ping' : ''"
                            class="bg-brand absolute inline-flex h-full w-full rounded-full opacity-75"
                        ></span>
                        <span class="bg-brand relative inline-flex h-3 w-3 rounded-full"></span>
                    </span>
                </div>
                <div class="flex items-center gap-2">View booking</div>
            </div>
        </MuvalButton>
    </Transition>
</template>

<script setup lang="ts">
import { openSummaryDialog } from '@/composables/dialog';
import MuvalButton from '@/components/button/MuvalButton.vue';
import { useSessionStore, useFormStore } from '@/store';

const form = useFormStore();
const session = useSessionStore();
</script>
